// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-mat-icon-checkbox-menu-item .mat-mdc-menu-item.selected {
  background: rgba(0, 29, 54, 0.0784313725);
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu-item/fi-mat-icon-checkbox-menu-item.component.scss"],"names":[],"mappings":"AACI;EACI,yCAAA;AAAR","sourcesContent":[".fi-mat-icon-checkbox-menu-item {\r\n    .mat-mdc-menu-item.selected {\r\n        background: #001d3614;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
